import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBadgeModule } from '@angular/material/badge';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { UiCommonModule, REG_HUB_DATE_FORMATS, RegHubDateAdapter } from 'reg-hub-common';
import { PendingOrderListComponent } from './pending-order-list/pending-order-list.component';
import { environment } from '../../environments/environment';
import { DraftOrderListComponent } from './draft-order-list/draft-order-list.component';
import { InvalidOrderListComponent } from './invalid-order-list/invalid-order-list.component';
import { OrderListComponent } from './order-list/order-list.component';
import { CompleteOrderListComponent } from './complete-order-list/complete-order-list.component';
import { NewSearchComponent } from './new-search/new-search.component';
import { NewRegistrationComponent } from './new-registration/new-registration.component';
import { BaseOrderInformationComponent } from './base-order-information/base-order-information.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderFeesComponent } from './order-fees/order-fees.component';
import { OrderStepperComponent } from './order-stepper/order-stepper.component';
import { DebtorsComponent } from './debtors/debtors.component';
import { SecuredPartiesComponent } from './secured-parties/secured-parties.component';
import { CollateralComponent } from './collateral/collateral.component';
import { AssetsComponent } from './assets/assets.component';
import { GeneralCollateralComponent } from './general-collateral/general-collateral.component';
import { ReviewComponent } from './review/review.component';
import { BaseOrderInformationReviewComponent } from './base-order-information-review/base-order-information-review.component';
import { BCLienDetailsComponent } from './lien-details/bc-lien-details/bc-lien-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmSubmitComponent } from './confirm-submit/confirm-submit.component';
import { DebtorSearchCriteriaComponent } from './debtor-search-criteria/debtor-search-criteria.component';
import { DebtorSearchReviewComponent } from './debtor-search-review/debtor-search-review.component';
import { OrderComponent } from './order/order.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { AssetSearchCriteriaComponent } from './asset-search-criteria/asset-search-criteria.component';
import { AssetSearchReviewComponent } from './asset-search-review/asset-search-review.component';
import { ABLienDetailsComponent } from './lien-details/ab-lien-details/ab-lien-details.component';
import { MBLienDetailsComponent } from './lien-details/mb-lien-details/mb-lien-details.component';
import { ONLienDetailsComponent } from './lien-details/on-lien-details/on-lien-details.component';
import { QCLienDetailsComponent } from './lien-details/qc-lien-details/qc-lien-details.component';
import { SKLienDetailsComponent } from './lien-details/sk-lien-details/sk-lien-details.component';
import { ACOLLienDetailsComponent } from './lien-details/acol-lien-details/acol-lien-details.component';
import { OnCollateralComponent } from './on-collateral/on-collateral.component';
import { ActionsComponent } from './actions/actions.component';
import { DealersComponent } from './dealers/dealers.component';
import { AssetListComponent } from './asset-list/asset-list.component';
import { DischargeDetailsComponent } from './discharge-details/discharge-details.component';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { TermComponent } from './term/term.component';
import { ConfirmCancelComponent } from './confirm-cancel/confirm-cancel.component';
import { RenewalComponent } from './renewal/renewal.component';
import { RegisteringAgentComponent } from './registering-agent/registering-agent.component';
import { OrderChangesComponent } from './order-changes/order-changes.component';
import { AmendmentDetailsComponent } from './amendment-details/amendment-details.component';
import { QCDischargeComponent } from './qc-discharge/qc-discharge.component';
import { HistoricalBCLienDetailsComponent } from './historical-lien-details/historical-bc-lien-details/historical-bc-lien-details.component';
import { ConfirmHistoricalComponent } from './confirm-historical/confirm-historical.component';
import { HistoricalABLienDetailsComponent } from './historical-lien-details/historical-ab-lien-details/historical-ab-lien-details.component';
import { HistoricalACOLLienDetailsComponent } from './historical-lien-details/historical-acol-lien-details/historical-acol-lien-details.component';
import { HistoricalMBLienDetailsComponent } from './historical-lien-details/historical-mb-lien-details/historical-mb-lien-details.component';
import { HistoricalONLienDetailsComponent } from './historical-lien-details/historical-on-lien-details/historical-on-lien-details.component';
import { HistoricalQCLienDetailsComponent } from './historical-lien-details/historical-qc-lien-details/historical-qc-lien-details.component';
import { HistoricalSKLienDetailsComponent } from './historical-lien-details/historical-sk-lien-details/historical-sk-lien-details.component';
import { BasicLienDetailsComponent } from './basic-lien-details/basic-lien-details.component';
import { DebtorComponent } from './debtor/debtor.component';
import { SecuredPartyComponent } from './secured-party/secured-party.component';
import { StaticWarningsComponent } from './static-warnings/static-warnings.component';
import { OrderValidationLogsComponent } from './order-validation-logs/order-validation-logs.component';
import { NewBusinessSearchComponent } from './new-business-search/new-business-search.component';
import { BusinessSearchCriteriaComponent } from './business-search-criteria/business-search-criteria.component';
import { BusinessSearchReviewComponent } from './business-search-review/business-search-review.component';
import { MatChipsModule } from '@angular/material/chips';
import { PrintOrderComponent } from './print-order/print-order.component';
import { BusinessReportCriteriaComponent } from './business-report-criteria/business-report-criteria.component';
import { BusinessReportReviewComponent } from './business-report-review/business-report-review.component';
import { DuplicateInComponent } from './duplicate-in/duplicate-in.component';
import { MultiSearchCriteriaComponent } from './multi-search-criteria/multi-search-criteria.component';
import { MultiSearchCriteriaValidationComponent } from './multi-search-criteria-validation/multi-search-criteria-validation.component';
import { MultiSearchReviewComponent } from './multi-search-review/multi-search-review.component';
import { RenewalReviewComponent } from './renewal-review/renewal-review.component';
import { DischargeReviewComponent } from './discharge-review/discharge-review.component';
import { AssignorsComponent } from './assignors/assignors.component';
import { AssignmentDetailsComponent } from './assignment-details/assignment-details.component';
import { CopyPartiesComponent } from './copy-parties/copy-parties.component';
import { AssigneesComponent } from './assignees/assignees.component';
import { SearchSummaryComponent } from './search-summary/search-summary.component';
import { SearchSummaryResultComponent } from './search-summary-result/search-summary-result.component';
import { RegistrationNumberSearchCriteriaComponent } from './registration-number-search-criteria/registration-number-search-criteria.component';
import { RegistrationNumberSearchReviewComponent } from './registration-number-search-review/registration-number-search-review.component';
import { OrderBundlesComponent } from './order-bundles/order-bundles.component';
import { AddToBundleComponent } from './add-to-bundle/add-to-bundle.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UltimateBeneficialOwnershipReportComponent } from './ultimate-beneficial-ownership-report/ultimate-beneficial-ownership-report.component';
import { UltimateBeneficialOwnershipReportReviewComponent } from './ultimate-beneficial-ownership-report-review/ultimate-beneficial-ownership-report-review.component';
import { PepsAndSanctionsReviewComponent } from './peps-and-sanctions-review/peps-and-sanctions-review.component';
import { PepsAndSanctionsPartiesComponent } from './peps-and-sanctions-parties/peps-and-sanctions-parties.component';
import { NewLandSearchComponent } from './new-land-search/new-land-search.component';
import { LandTitleSearchCriteriaComponent } from './land-title-search-criteria/land-title-search-criteria.component';
import { UsBusinessSearchCriteriaComponent } from './us-business-search-criteria/us-business-search-criteria.component';
import { UsBusinessSearchReviewComponent } from './us-business-search-review/us-business-search-review.component';
import { LandTitleSearchCriteriaReviewComponent } from './land-title-search-criteria-review/land-title-search-criteria-review.component';
import { BaseKnowYourCustomerInformationComponent } from './base-know-your-customer-information/base-know-your-customer-information.component';
import { NewKnowYourCustomerComponent } from './new-know-your-customer/new-know-your-customer.component';
import { KnowYourCustomerCriteriaComponent } from './know-your-customer-criteria/know-your-customer-criteria.component';
import { KnowYourCustomerCriteriaReviewComponentComponent } from './know-your-customer-criteria-review-component/know-your-customer-criteria-review-component.component';
import { LinkToHubReportDialogComponent } from './link-to-hub-report-dialog/link-to-hub-report-dialog.component';
import { ResendMessageDialog } from './resend-message-dialog/resend-message-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [
    PendingOrderListComponent,
    DraftOrderListComponent,
    InvalidOrderListComponent,
    OrderListComponent,
    CompleteOrderListComponent,
    NewSearchComponent,
    NewRegistrationComponent,
    BaseOrderInformationComponent,
    OrderFeesComponent,
    OrderStepperComponent,
    DebtorsComponent,
    SecuredPartiesComponent,
    CollateralComponent,
    AssetsComponent,
    GeneralCollateralComponent,
    ReviewComponent,
    BaseOrderInformationReviewComponent,
    BCLienDetailsComponent,
    ConfirmSubmitComponent,
    ConfirmDeleteComponent,
    DebtorSearchCriteriaComponent,
    DebtorSearchReviewComponent,
    OrderComponent,
    OrderDetailsComponent,
    AssetSearchCriteriaComponent,
    AssetSearchReviewComponent,
    ABLienDetailsComponent,
    MBLienDetailsComponent,
    ONLienDetailsComponent,
    QCLienDetailsComponent,
    SKLienDetailsComponent,
    ACOLLienDetailsComponent,
    OnCollateralComponent,
    ActionsComponent,
    DealersComponent,
    AssetListComponent,
    DischargeDetailsComponent,
    TermComponent,
    ConfirmCancelComponent,
    RenewalComponent,
    RegisteringAgentComponent,
    DebtorComponent,
    SecuredPartyComponent,
    OrderChangesComponent,
    AmendmentDetailsComponent,
    QCDischargeComponent,
    HistoricalBCLienDetailsComponent,
    ConfirmHistoricalComponent,
    HistoricalABLienDetailsComponent,
    HistoricalACOLLienDetailsComponent,
    HistoricalMBLienDetailsComponent,
    HistoricalONLienDetailsComponent,
    HistoricalQCLienDetailsComponent,
    HistoricalSKLienDetailsComponent,
    BasicLienDetailsComponent,
    StaticWarningsComponent,
    OrderValidationLogsComponent,
    NewBusinessSearchComponent,
    BusinessSearchCriteriaComponent,
    BusinessSearchReviewComponent,
    PrintOrderComponent,
    BusinessReportCriteriaComponent,
    BusinessReportReviewComponent,
    PrintOrderComponent,
    DuplicateInComponent,
    MultiSearchCriteriaComponent,
    MultiSearchCriteriaValidationComponent,
    MultiSearchReviewComponent,
    RenewalReviewComponent,
    DischargeReviewComponent,
    AssignorsComponent,
    AssigneesComponent,
    AssignmentDetailsComponent,
    CopyPartiesComponent,
    SearchSummaryComponent,
    SearchSummaryResultComponent,
    RegistrationNumberSearchCriteriaComponent,
    RegistrationNumberSearchReviewComponent,
    OrderBundlesComponent,
    AddToBundleComponent,
    UltimateBeneficialOwnershipReportComponent,
    UltimateBeneficialOwnershipReportReviewComponent,
    PepsAndSanctionsReviewComponent,
    PepsAndSanctionsPartiesComponent,
    NewLandSearchComponent,
    LandTitleSearchCriteriaComponent,
    UsBusinessSearchCriteriaComponent,
    UsBusinessSearchReviewComponent,
    LandTitleSearchCriteriaReviewComponent,
    BaseKnowYourCustomerInformationComponent,
    NewKnowYourCustomerComponent,
    KnowYourCustomerCriteriaComponent,
    KnowYourCustomerCriteriaReviewComponentComponent,
    LinkToHubReportDialogComponent,
    ResendMessageDialog
  ],
  imports: [
    TranslocoModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material Design imports
    MatProgressSpinnerModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSelectModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatDialogModule,
    MatBadgeModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatSortModule,
    MatGridListModule,
    MatTabsModule,
    MatRippleModule,
    MatStepperModule,
    MatExpansionModule,
    MatChipsModule,
    BrowserAnimationsModule,
    NgxMatSelectSearchModule,
    MatChipsModule,
    UiCommonModule.forRoot({ rootUrl: environment.urlAddress, batchRootURL: environment.batchUrlAddress, consortiumRootURL: environment.consortiumUrlAddress })
  ],
  exports: [
    BaseOrderInformationComponent,
    DraftOrderListComponent,
    InvalidOrderListComponent,
    PendingOrderListComponent,
    CompleteOrderListComponent,
    SecuredPartiesComponent,
    DebtorsComponent,
    AssetsComponent,
    ReviewComponent,
    BCLienDetailsComponent
  ],
  providers: [
    { provide: DateAdapter, useClass: RegHubDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: REG_HUB_DATE_FORMATS }
  ]
})
export class OrdersModule { }
